<template>
  <div class="double-scrollbar">
    <div ref="topScroll" class="double-scrollbar-top-scroll">
      <div ref="scrollBar" :style="scrollBarStyle">&nbsp;</div>
    </div>
    <div class="double-scrollbar-scroll-area" ref="scrollArea" :class="className">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'vueDoubleScrollbar',
  props: ['watch', 'className'],
  inheritAttrs: false,
  data: () => ({
    sWidth: '',
    init: false,
  }),
  computed: {
    scrollBarStyle() {
      return { paddingTop: '1px', width: this.sWidth }
    },
  },
  methods: {
    isPC() {
      return window.matchMedia('(min-width: 768px)').matches
    },
    initScrollbar() {
      if (this.init || !this.isPC()) return
      this.init = true
      let topScroll = this.$refs.topScroll
      let childWrapper = this.$refs.scrollArea
      this.setWidth()
      topScroll.addEventListener(
        'scroll',
        () => {
          childWrapper.scrollLeft = topScroll.scrollLeft
        },
        { passive: true }
      )
      childWrapper.addEventListener(
        'scroll',
        () => {
          topScroll.scrollLeft = childWrapper.scrollLeft
        },
        { passive: true }
      )
      window.addEventListener('resize', this.setWidth, { passive: true })
    },
    getWidth() {
      let width = null
      if (this.$refs.scrollArea && this.$refs.scrollArea.scrollWidth) {
        width = this.$refs.scrollArea.scrollWidth + 'px'
      }
      return width
    },
    setWidth() {
      if (!this.init) this.initScrollbar()
      let width = this.getWidth()
      if (width == null) {
        width = 'auto'
      }
      if (width !== this.sWidth) {
        this.sWidth = width
      }
    },
  },
  mounted() {
    this.initScrollbar()
  },
  watch: {
    watch: {
      deep: true,
      handler() {
        this.$nextTick(() => this.setWidth())
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWidth)
  },
}
</script>

<style lang="scss">
.double-scrollbar-top-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.double-scrollbar-scroll-area {
  overflow: auto;
  overflow-y: hidden;
}
</style>
